// extracted by mini-css-extract-plugin
export default {"grayText":"ReferralParts_grayText__7VcY6","header":"ReferralParts_header__NLEwa"};